export default __webpack_public_path__ + "static/media/noSubjects.a93d76ee.svg";